exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-72f471c1] {\n  max-width: 250px;\n}\n", ""]);

// exports
